import { useTranslation, Trans } from 'react-i18next';
import { useEffect, useState } from 'react';
import { format } from 'react-string-format';
import '../../../i18n';
import ReactHtmlParser from 'html-react-parser';

import Button from '../../UI/Buttons/Button';
import DOMPurify from 'dompurify';
export function RetentionOffer(props) {

    const { t, i18n } = useTranslation();
    const [nextPage, setNextPage] = useState("");
    const {
        campaignData,
        handlePageChange, 
        isDiscountApplied,
        discountValue,
        showAddedTax,
        frequencyText,
        subsName,
        description,
        offerHeading,
        offerIntro, 
        frequencyInMonths,
        prevPriceValue,
        newPriceValue,
        freqDescription} = props;


        const getNextPage = () =>{
     
                if(campaignData?.showCancellationForm){
                   return "CANCELLATION_REASONS";
                }else{
                    return "ORDER_CANCELLATION";
                }
        }
    
        useEffect(()=>{
            
            let page = getNextPage();
            setNextPage(page);
    
        }, [campaignData])

    return (
        <div className="container center-text retention-offer"> 
            <div className="item-container">
                <div className="item-wrapper">
                <h1 class="block-header">{offerHeading} </h1>
                    <p>{offerIntro} </p>
                </div>
            </div>
            <div className="card">
     
                <div className="item-container">
                 
                    <div className="item-wrapper">

                       {isDiscountApplied && <p className="rounded-elem xsmall-text">{format(t("retentionoffer.savetext"), discountValue)}</p>}

                        <div className="price-wrapper">

                            {isDiscountApplied ? <>
                                <span className="previous-price xlarge"><s><strong>{prevPriceValue}</strong></s></span>
                                <span className="xxlarge"> <strong>{newPriceValue}</strong></span> {showAddedTax ? <p>{t('retentionoffer.addedtaxstring')}</p> : ""}
                            </> :
                            <span className="xxlarge"> <strong>{prevPriceValue}{freqDescription}</strong>{showAddedTax ? <p>{t('retentionoffer.addedtaxstring')}</p> : ""}
                            </span>}

                        </div>

                        {isDiscountApplied ? <p className="small-text">{frequencyText}</p> : ""  }

                    </div>
                
                    <div className="item-wrapper offer-name">
                        <h2>{subsName}</h2>
                    </div>
                    
                    <div className="item-wrapper offer-description">
                         {ReactHtmlParser(DOMPurify.sanitize(description || ""))}
                     </div>
             
                </div>
                    <div className="item-container">
                        <div className="item-wrapper center-flex-row">
                            <Button type="button" buttonSize="medium" btnType="ghost" onClick={()=>{handlePageChange(nextPage)}}>{t('retentionoffer.continuetocancelbuttontext')}</Button>
                            <Button type="button" buttonSize="medium" onClick={()=>{handlePageChange("RETENTION_OFFER_ACCEPTANCE")}}>{t('retentionoffer.acceptofferbuttontext')}</Button>
                        </div>
                    </div>
                </div>
   
         
         </div>
  
    );
}